import { useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useHeaderContext } from "../../../../context/headerContext";
import { useDrawerContext } from "../../../../context/drawerContext";
import DropDown from '../../../../components/Dropdown';
import Button from '../../../../components/Button';
import CloseIcon from "/public/images/icons/close.svg?react";
import { format } from 'date-fns';

const formatDOB = (dob) => {
  if (!dob) return dob;
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dob)) return dob;
  const isoMatch = dob.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
  return dob;
};

export default function ParticipantBookingProfile() {

  const { setTitle, setBackButton, setEditFunc, setBackButtonFunc } = useHeaderContext();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const { state } = useLocation();
  const { bookingId, participantId } = useParams();
  const navigate = useNavigate();
  const participant = state;
  const isActive = participant?.isBookedIn === 1 || participant?.bandStatus === 'active';

  useEffect(() => {
    setTitle(participant?.participantName);
    setBackButton(true);
    setBackButtonFunc(() => navigate(`/bookings/${bookingId}`));
    //setEditFunc(LogErrors(user, logout, updateTokens, 'edit'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(() => {
  //   if (participant?.bandStatus !== 'active') {
  //     assignBand();
  //   }
  // }, []);

  const bandLost = () => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            BAND LOST
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-4 justify-stretch">
          <h3 className="text-[24px]">Band Lost?</h3>
          <p className=" text-sportsDarkGrey">
            Temporarily deactivate your band so that the QR code on the band cannot be unlocked.
          </p>
          <Button variant='primary'>Temporarily Deactivate Band</Button>
          <Button variant='tertiary' className="underline">Keep Band</Button>
        </div>
      </div>
    );
  };

  const bandStolen = () => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            BAND STOLEN
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-4 justify-stretch">
          <h3 className="text-[24px]">Band Stolen?</h3>
          <p className=" text-sportsDarkGrey">
            Temporarily deactivate your band so that the QR code on the band cannot be unlocked.
          </p>
          <Button variant='primary' onClick={deactivateBand()}>Permanently Deactivate Band</Button>
          <Button variant='tertiary' className="underline">Keep Band</Button>
        </div>
      </div>
    )
  }

  const deactivateBand = () => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            DEACTIVATE BAND
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-4 justify-stretch">
          <h3 className="text-[24px]">Permanently deactivate band, are you sure?</h3>
          <p className=" text-sportsDarkGrey">
            All information will be deleted and the band will no longer work.
          </p>
          <Button variant='primary'>Deactivate Band and Order a New One</Button>
          <Button variant='tertiary' className="underline">Keep Band</Button>
        </div>
      </div>
    );
  }

  const assignBand = () => {
    setOpen(true);
    setDrawerContent (
      <div className='flex flex-col w-full'>
        <Button variant='primary'>Assign Band</Button>
      </div>
    )
  }

  //LogErrors(user, logout, updateTokens, participant);

  return (
    <div className='mt-[20px]'>
      <div className='p-[24px] mb-[15px]'>
        {isActive ? (
          <div className="border-[1px] border-[#E3E3E3] h-[200px] rounded-[4px] mr-5 relative flex items-center p-6"
            style={{ background: "linear-gradient(151.5deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.1) 50%, #101820 50.1%, #101820 100%)" }}
          >
            <div className="flex flex-col gap-y-2 z-10">
              <span className="text-[11px] font-semibold uppercase tracking-[2px] bg-white rounded-[4px] px-[9px] py-[3px] w-fit">BOOKED IN</span>
            </div>
            <img
              src={participant?.bandImageURL ?? "/images/grey-band.png"}
              alt="band"
              className="max-w-[175px] mx-auto right-[-20px] absolute object-contain"
            />
          </div>
        ) : (
          <button
            className="bg-[#F8F8F8] border-[1px] border-[#E3E3E3] h-[200px] rounded-[4px] mr-5 relative flex items-center p-6 w-full text-left"
            onClick={() => navigate('/bookings/assign-band/scan', { state: { participant, bookingId, participantId } })}
          >
            <div className="flex flex-col gap-y-2 z-10">
              <p className="font-semibold underline text-sportsBlack">+Add</p>
              <span className="text-[11px] font-semibold uppercase tracking-[2px] bg-white rounded-[4px] px-[9px] py-[3px] w-fit">NOT ASSIGNED</span>
            </div>
            <img src="/images/grey-band.png" alt="band" className="max-w-[175px] mx-auto right-[-20px] absolute" />
          </button>
        )}
        <div className='mt-[60px] mb-[30px] pb-[30px] border-b border-dashed border-[#E3E3E3]'>
          <p className='font-poppins font-semibold text-[24px]'>{participant?.participantName}</p>
          {participant?.isLeadParticipant === 1 && (
            <p className='font-poppins text-[12px] font-semibold uppercase tracking-widest text-sportsDarkGrey'>Lead Participant</p>
          )}
          <p className='font-poppins text-[#727272]'>{isActive ? 'Active Band' : 'No Active Band'}</p>
        </div>
        <div className='flex flex-col gap-4'>
          {participant?.participantDOB && (
            <div className='flex flex-col gap-y-1'>
              <p className='font-poppins font-semibold text-[16px]'>Date of Birth</p>
              <p className='font-poppins text-[#727272]'>{formatDOB(participant.participantDOB)}</p>
            </div>
          )}
          {(participant?.guestEmail || participant?.guestEmailName) && (
            <div className='flex flex-col gap-y-1'>
              <p className='font-poppins font-semibold text-[16px]'>Email</p>
              <p className='font-poppins text-[#727272]'>{participant.guestEmail || participant.guestEmailName}</p>
            </div>
          )}
          {participant?.isIncomplete === 1 && (
            <div className='flex flex-col gap-y-1'>
              <span className='text-[11px] font-semibold uppercase tracking-[2px] bg-sportsRed text-white rounded-[4px] px-[9px] py-[3px] w-fit'>Profile Incomplete</span>
            </div>
          )}
          {participant?.primaryEmergencyContactName && (
            <div className='flex flex-col gap-y-1'>
              <p className='font-poppins font-semibold text-[16px]'>Primary Emergency Contact Name (ICE)</p>
              <p className='font-poppins text-[#727272]'>{participant.primaryEmergencyContactName}</p>
            </div>
          )}
          {participant?.primaryContactNumber && (
            <div className='flex flex-row gap-y-1 justify-between'>
              <div>
                <p className='font-poppins font-semibold text-[16px]'>Primary Emergency Contact Number</p>
                <Link to={`tel:${participant.primaryContactNumber}`} className='font-poppins text-[#727272] underline'>{participant.primaryContactNumber}</Link>
              </div>
              <div className='flex flex-col justify-center items-center'>
                <Link to={`tel:${participant.primaryContactNumber}`} className='flex items-center gap-x-2 text-sportsBlue'>
                  <img src='/images/icons/phone.svg' alt='phone' className='w-[24px] h-[24px]' />
                </Link>
              </div>
            </div>
          )}
          {participant?.primaryContactRelationship && (
            <div className='flex flex-col gap-y-1'>
              <p className='font-poppins font-semibold text-[16px]'>Primary Emergency Contact Relationship</p>
              <p className='font-poppins text-[#727272]'>{participant.primaryContactRelationship}</p>
            </div>
          )}
          {participant?.primaryMedicalCondition && (
            <div className='flex flex-col gap-y-1'>
              <p className='font-poppins font-semibold text-[16px]'>Primary Medical Condition</p>
              <p className='font-poppins text-[#727272]'>{participant.primaryMedicalCondition}</p>
            </div>
          )}
          {participant?.notes && (
            <div className='flex flex-col gap-y-1'>
              <p className='font-poppins font-semibold text-[16px]'>Notes</p>
              <p className='font-poppins text-[#727272]'>{participant.notes}</p>
            </div>
          )}
        </div>
      </div>
      <div className='flex flex-col gap-y-[10px] bg-sportsLightGrey p-[24px]'>
        <DropDown title='Medical History' icon="medical">
          <div className='flex flex-col gap-y-3'>
          {participant?.medicalHistory?.map((medicalHistory, index) => (
            <div key={index} className='flex flex-col'>
              <p className='font-poppins text-[16px] font-semibold'>{medicalHistory.condition}</p>
              <p className='font-poppins text-[#727272]'>{medicalHistory.diagnosisDate}</p>
            </div>
          ))}
          </div>
        </DropDown>
        <DropDown title="Allergies" icon="allergy">
          <div className='flex flex-col gap-y-3'>
          {participant?.allergies?.map((allergy, index) => (
            <div key={index} className='flex flex-col'>
              <p className='font-poppins font-normal text-[16px]'>{allergy.name}</p>
            </div>
          ))}
          </div>
        </DropDown>
        <DropDown title="Medications" icon="medication">
          <div className='flex flex-col gap-y-3'>
          {participant?.medications?.map((medication, index) => (
            <div key={index} className='flex flex-col'>
              <p className='font-poppins text-[16px] font-semibold'>{medication.name}</p>
              <p className='font-poppins text-[#727272]'>{medication.dosage}</p>
            </div>
          ))}
          </div>
        </DropDown>
        <DropDown title="Other Emergency Contacts" icon="contact">
          <div className='flex flex-col gap-y-3'>
          {participant?.otherEmergencyContacts?.map((contact, index) => (
            <div key={index} className='flex flex-col'>
              <p className='font-poppins font-normal text-[16px]'>{contact.name}</p>
              <p className='font-poppins text-[#727272]'>{contact.relationship}</p>
              <Link to={`tel:${contact.phoneNumber}`} className='font-poppins text-[#727272] underline'>{contact.phoneNumber}</Link>
            </div>
          ))}
          </div>
        </DropDown>
        <DropDown title="Incident History" icon="/public/images/icons/incidentHistoryIcon.svg?react">
          <div className='flex flex-col gap-y-3'>
          {participant?.incidentHistory?.map((incident, index) => (
            <div key={index} className='flex flex-col'>
              <p className='font-poppins text-[16px] font-semibold'>{format(new Date(incident.date), 'dd/MM/yyyy HH:mm:ss')}</p>
              <p className='font-poppins text-[#727272]'>{incident.description}</p>
            </div>
          ))}
          </div>
        </DropDown>
      </div>
      <div className='flex flex-col mt-[24px] mb-[75px] gap-y-[10px]'>
        <button className='font-semibold font-poppins text-[16px] text-sportsBlack bg-sportsLightGrey w-max mx-auto' onClick={bandLost}>Band Lost?</button>
        <button className='font-semibold font-poppins text-[16px] text-sportsRed' onClick={bandStolen}>Band Stolen?</button>
      </div>
    </div>
  );
}